module.exports = __webpack_public_path__ + "static/media/bookmark-solid.c0772195.svg";